import type {EventBusKey} from '@vueuse/core';

type AddEvent = {
	type: 'add';
	shoppingListId: string;
	productId: string;
};

type RemoveEvent = {
	type: 'remove';
	shoppingListId: string;
	productId: string;
};

export const shoppingListsBusKey: EventBusKey<AddEvent | RemoveEvent> = Symbol('shoppingListsBus');
